require('./src/svg4everybodyinit')
require('./src/toBlob-polyfill')

var smoothscroll = require('smoothscroll-polyfill');

// kick off the polyfill!
smoothscroll.polyfill();

// if (typeof HtmlFormControlsCollection == 'undefined') {
//   function HtmlFormControlsCollection( arr ) {
//     for ( var i = 0; i < arr.length; i += 1 ) {
//       this[i] = arr[i];
//     }
//
//     // length is readonly
//     Object.defineProperty( this, 'length', {
//       get: function () {
//         return arr.length;
//       }
//     });
//
//     // a HTMLCollection is immutable
//     Object.freeze( this );
//   }
//
//   HtmlFormControlsCollection.prototype = {
//     item: function ( i ) {
//       return this[i] != null ? this[i] : null;
//     },
//     namedItem: function ( name ) {
//       var ret = [];
//       for ( var i = 0; i < this.length; i += 1 ) {
//         if ( this[i].id === name || this[i].name === name ) {
//           ret.push(this[i]);
//         }
//       }
//       return ret.length ? ret : null;
//     }
//   };
// }
//
// var oldElements = HTMLFormElement.prototype.__lookupGetter__('elements');
//
// HTMLFormElement.prototype.__defineGetter__('elements', function() {
//   var elems = oldElements.call(this);
//   if (typeof HtmlFormControlsCollection !== 'undefined' && elems instanceof HtmlFormControlsCollection) {
//     return elems;
//   }
//
//   return new HtmlFormControlsCollection(elems);
// });

// Polyfills <button /> which do not support the form* attributes ~ IE 11 to Edge 15
function buttonFormTarget(e) {
  var button = e.target.closest('button[form]')
  if (button) {
    var formId = button.getAttribute('form')
    var form = document.forms[formId]
    if (button.hasAttribute('formmethod')) {
      form.method = button.getAttribute('formmethod')
    }
    if (button.hasAttribute('formenctype')) {
      form.enctype = button.getAttribute('formenctype')
    }

    form.dispatchEvent(new Event('submit', {bubbles:true}))
  }
}

// Identify the Browser
if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
  var ua = window.navigator.userAgent;
  var edge = ua.indexOf('Edge/');
  console.log(parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10))
  // Edge (IE 12+) => return version number
  if (edge > 0) {
    if (parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10) < 16) {
      window.addEventListener('click', buttonFormTarget)
    }
  } else {
   window.addEventListener('click', buttonFormTarget)
  }
}

if (!HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
  Object.defineProperty(HTMLSelectElement.prototype, "selectedOptions", {
    get: (function() {
      try {
        document.querySelector(":checked");
        return function() {
          return this.querySelectorAll(":checked");
        };
      } catch (e) {
        return function() {
          if (!this.multiple) {
            return this.selectedIndex >= 0
              ? [this.options[this.selectedIndex]] : [];
          }
          for (var i = 0, a = []; i < this.options.length; i++)
            if (this.options[i].selected) a.push(this.options[i]);
          return a;
        };
      }
    })()
  });
}
